export class Patrimonial {

    constructor(config = {}) {
        this.model = {
            id: {
                value: null,
                header: 'Código',
            },
            corriente: { 
                value: 0, 
                header: 'Corriente:', 
                required: 'Valor requerido.' 
            },
            fijo: { 
                value: 0, 
                header: 'Fijo:', 
                required: 'Valor requerido.' 
            },
            otros_activos: { 
                value: 0, 
                header: 'Otros activos:', 
                required: 'Valor requerido.' 
            },
            total_activo: { 
                value: 0, 
                header: 'Total activo:', 
                required: 'Valor requerido.' 
            },
            total_ingresos: { 
                value: 0, 
                header: 'Total de ingresos:', 
                required: 'Valor requerido.' 
            },
            corto_plazo: { 
                value: 0, 
                header: 'Corto plazo:', 
                required: 'Valor requerido.' 
            },
            largo_plazo: { 
                value: 0, 
                header: 'Largo plazo:', 
                required: 'Valor requerido.' 
            },
            total_pasivos: { 
                value: 0, 
                header: 'Total pasivos:', 
                required: 'Valor requerido.' 
            },
            patrimonio: {
                value: 0,
                header: 'Patrimonio:',
                required: 'Valor requerido.'
            },
            total_egresos: { 
                value: 0, 
                header: 'Total de egresos:', 
                required: 'Valor requerido.' 
            },
        }
    }
}
